//helpers
    import { Request } from 'api'
    import { mapToObject } from 'helpers/Objects'
    import moment from 'moment'
    
//constatnts
    import * as ActionsState from 'constants/ActionsState'

export default class DataStatus {
    static getInitialData( list ) {
        return list.reduce(( dataStatus, name ) => ({
            ...dataStatus,
            [name]: {
                status: ActionsState.NOT_LOAD
            }
        }), {})
    }

    constructor( core ) {
        this.core = core
    }

    setInfoRequest = ( name, status, data ) => {
        return {
            data_status: {
                [ name ]: {
                    status: {$set: status },
                    ...mapToObject( data, ( key, value ) => ({
                        key,
                        value: ({ $set: value })
                    }))
                }
            }
        }
    }

    setInfo = ( ...args ) => {
        this.core.updateStore( this.setInfoRequest( ...args ), `DataStatus::setInfo "${args[0]}" => "${args[1]}"` )
    }

    createTransaction = ( name ) => {
        const dataStatus = this

        return {
            loading() {
                dataStatus.setInfo( name, ActionsState.LOADING )
            },
            done( data ) {
                return dataStatus.setInfoRequest( name, ActionsState.LOADED, data )
            },
            error( error, data = {} ) {
                console.error('Transaction fail: ')
                console.error( error )

                dataStatus.setInfo( name, ActionsState.HAS_ERROR, { ...data, error: error } )
            }
        }
    }

    createRequest = ( from, to ) => {
        const dataStatus = this

        const [api, data] = from

        const { store, updateStore } = this.core

        const { origin } = store.getState()

        const dataTransaction = dataStatus.createTransaction( to )

        dataTransaction.loading()

        let callbacks = []

        let callbacksError = []

        return {
            onComplete( fn ) {
                callbacks.push( fn )

                return this
            },
            onError( fn ) {
                callbacksError.push( fn )

                return this
            },
            async start({ logName = "", debug = false }) {
                if( debug ) console.log( `%cRequest %capi %c${api.name} %cstart at ${moment().format('HH:mm:ss')}`,
                    'color: #3F7CE9;',
                    `color: #fff`,
                    'font-weight: bold; color: #F78156;',
                    'color: rgba(0,0,0,0.6);'
                )

                try {
                    const response = await Request( api, { origin, ...data })

                    if( debug ) console.log( `%cRequest %capi %c${api.name} %cend at ${moment().format('HH:mm:ss')}`,
                        'color: #3F7CE9;',
                        `color: #fff`,
                        'font-weight: bold; color: #F78156;',
                        'color: rgba(0,0,0,0.6);'
                    )

                    if( debug ) console.log( 'Response: ', response )

                    updateStore({
                        [to]: {$set: response },
                        ...dataTransaction.done()
                    }, logName )

                    callbacks.forEach( fn => fn( response ) )

                    return true
                } catch( e ) {
                    dataTransaction.error( e )

                    callbacksError.forEach( fn => fn( e ) )

                    if( debug ) console.log( `%cRequest %capi %c${api.name} %cthrow at ${moment().format('HH:mm:ss')}`,
                        'color: #3F7CE9;',
                        `color: #fff`,
                        'font-weight: bold; color: #F78156;',
                        'color: rgba(254,0,0,0.6);'
                    )

                    if( debug ) console.log( 'Error: ', e )
                }

                return false
            }
        }
    }

    isLoaded = ( name ) => {
        const { store } = this.core

        const { data_status } = store.getState()

        return data_status[ name ].status == ActionsState.LOADED
    }
}